/* ============================================================
   Cable Assembly Form — cable-assembly-form.js
   Initialises every .caf[data-section-id] on the page.
   Works with multiple section instances and Shopify theme editor.
   ============================================================ */

(function () {
  'use strict';

  /* ── Global click-outside listener (registered once) ── */
  if (!document._cafClickOutsideRegistered) {
    document._cafClickOutsideRegistered = true;
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.caf__dropdown:not([hidden])').forEach(function (dd) {
        var wrap = dd.closest('.caf__search-wrap');
        if (wrap && !wrap.contains(e.target)) {
          dd.hidden = true;
        }
      });
    });
  }

  /* ============================================================
     CableAssemblyForm — one instance per .caf container
     ============================================================ */
  function CableAssemblyForm(container) {
    var sid = container.getAttribute('data-section-id');
    if (!sid) return;

    /* DOM refs — elements inside .caf use container-relative queries */
    var rowsEl      = container.querySelector('.caf__rows');
    var addBtn      = container.querySelector('.caf__add-btn');
    var submitBtn   = container.querySelector('.caf__submit-btn');
    var custEmail   = container.querySelector('#caf-cust-email-' + sid);
    var custName    = container.querySelector('#caf-cust-name-'  + sid);
    var formContent = container.querySelector('.caf__form-content');
    var jsSuccess   = container.querySelector('.caf__js-success');
    var jsNotice    = container.querySelector('.caf__js-success-notice');

    /* Elements outside .caf (inside the {% form %} wrapper) */
    var contactForm  = document.getElementById('caf-form-'          + sid);
    var hiddenSubmit = document.getElementById('caf-hidden-submit-' + sid);
    var bodyField    = document.getElementById('caf-body-'          + sid);
    var emailHidden  = document.getElementById('caf-email-hidden-'  + sid);
    var nameHidden   = document.getElementById('caf-name-hidden-'   + sid);

    /* Row template (outside the form, after {% endform %}) */
    var rowTpl = document.getElementById('caf-row-tpl-' + sid);

    var MAX_ROWS     = parseInt(addBtn ? addBtn.getAttribute('data-max') : 5, 10);
    var debounceMap  = new WeakMap();

    /* ----------------------------------------------------------
       Search
    ---------------------------------------------------------- */
    function initSearchField(field) {
      var input    = field.querySelector('.caf__search-input');
      var dropdown = field.querySelector('.caf__dropdown');
      var hidden   = field.querySelector('.caf__selected-value');
      var filter   = field.getAttribute('data-filter') || '';

      if (!input || !dropdown) return;

      input.addEventListener('input', function () {
        var q = this.value.trim();
        hidden.value = '';
        input.classList.remove('caf__input--selected');
        clearTimeout(debounceMap.get(input));

        if (q.length < 2) {
          dropdown.hidden = true;
          return;
        }

        debounceMap.set(input, setTimeout(function () {
          fetchProducts(q, filter, dropdown, input, hidden);
        }, 280));
      });

      input.addEventListener('keydown', function (e) {
        handleKeyboard(e, dropdown, input, hidden);
      });

      /* re-open if user focuses and dropdown already has results */
      input.addEventListener('focus', function () {
        if (dropdown.children.length > 0) dropdown.hidden = false;
      });
    }

    function fetchProducts(query, filter, dropdown, input, hidden) {
      var q   = filter ? query + ' ' + filter : query;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=product&resources[limit]=6';

      showLoading(dropdown);

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (
            data.resources &&
            data.resources.results &&
            data.resources.results.products
          ) || [];
          renderDropdown(products, dropdown, input, hidden);
        })
        .catch(function () { dropdown.hidden = true; });
    }

    function showLoading(dropdown) {
      dropdown.innerHTML = '<li class="caf__dropdown-loading">Searching…</li>';
      dropdown.hidden = false;
    }

    function renderDropdown(products, dropdown, input, hidden) {
      dropdown.innerHTML = '';

      if (!products.length) {
        dropdown.innerHTML = '<li class="caf__dropdown-no-results">No products found</li>';
        dropdown.hidden = false;
        return;
      }

      products.forEach(function (product) {
        var li = document.createElement('li');
        li.className = 'caf__dropdown-item';
        li.setAttribute('role', 'option');
        li.setAttribute('tabindex', '-1');

        var imgSrc = product.image
          || (product.featured_image && product.featured_image.url)
          || '';

        var imgHtml = imgSrc
          ? '<img class="caf__dropdown-img" src="' + imgSrc + '" alt="" loading="lazy">'
          : '<div class="caf__dropdown-img-placeholder"></div>';

        li.innerHTML = imgHtml
          + '<span class="caf__dropdown-title">' + escapeHtml(product.title) + '</span>';

        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          input.value  = product.title;
          hidden.value = product.title + ' (https://' + Shopify.shop + product.url.split('?')[0] + ')';
          input.classList.add('caf__input--selected');
          dropdown.hidden = true;
        });

        dropdown.appendChild(li);
      });

      dropdown.hidden = false;
    }

    function handleKeyboard(e, dropdown, input, hidden) {
      if (dropdown.hidden) return;

      var items  = dropdown.querySelectorAll('.caf__dropdown-item');
      var active = dropdown.querySelector('.caf__dropdown-item.is-active');

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          var next = active ? active.nextElementSibling : items[0];
          if (next) {
            if (active) active.classList.remove('is-active');
            next.classList.add('is-active');
          }
          break;

        case 'ArrowUp':
          e.preventDefault();
          var prev = active ? active.previousElementSibling : items[items.length - 1];
          if (prev) {
            if (active) active.classList.remove('is-active');
            prev.classList.add('is-active');
          }
          break;

        case 'Enter':
          if (active) {
            e.preventDefault();
            active.dispatchEvent(new MouseEvent('mousedown'));
          }
          break;

        case 'Escape':
          dropdown.hidden = true;
          input.blur();
          break;
      }
    }

    /* ----------------------------------------------------------
       Row init (search fields + remove button)
    ---------------------------------------------------------- */
    function initRow(row, isFirst) {
      row.querySelectorAll('.caf__field[data-search-type]').forEach(initSearchField);

      var removeBtn = row.querySelector('.caf__remove-btn');
      if (removeBtn) {
        if (isFirst) {
          removeBtn.parentElement.style.visibility = 'hidden';
        } else {
          removeBtn.addEventListener('click', function () { removeRow(row); });
        }
      }
    }

    /* ----------------------------------------------------------
       Add More
    ---------------------------------------------------------- */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var count = parseInt(this.getAttribute('data-count'), 10);
        if (count >= MAX_ROWS) return;

        var clone  = rowTpl.content.cloneNode(true);
        var newRow = clone.querySelector('.caf__row');

        newRow.classList.add('caf__row--entering');
        newRow.addEventListener('animationend', function () {
          newRow.classList.remove('caf__row--entering');
        }, { once: true });

        rowsEl.appendChild(newRow);
        initRow(newRow, false);

        count++;
        this.setAttribute('data-count', count);
        if (count >= MAX_ROWS) this.disabled = true;
      });
    }

    function removeRow(row) {
      row.style.transition = 'opacity 0.18s, transform 0.18s';
      row.style.opacity    = '0';
      row.style.transform  = 'translateX(-8px)';
      setTimeout(function () {
        row.remove();
        var count = parseInt(addBtn.getAttribute('data-count'), 10) - 1;
        addBtn.setAttribute('data-count', count);
        if (count < MAX_ROWS) addBtn.disabled = false;
      }, 200);
    }

    /* ----------------------------------------------------------
       Submit
    ---------------------------------------------------------- */
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var email = custEmail ? custEmail.value.trim() : '';
        var name  = custName  ? custName.value.trim()  : '';
        var valid = true;

        /* validate email */
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (custEmail) custEmail.classList.add('caf__input--error');
          valid = false;
        } else {
          if (custEmail) custEmail.classList.remove('caf__input--error');
        }

        /* validate name */
        if (!name) {
          if (custName) custName.classList.add('caf__input--error');
          valid = false;
        } else {
          if (custName) custName.classList.remove('caf__input--error');
        }

        /* build message body from rows */
        var rows  = rowsEl.querySelectorAll('.caf__row');
        var lines = [];
        var idx   = 0;

        rows.forEach(function (row) {
          idx++;
          var leftVal     = getFieldValue(row, 'left');
          var rightVal    = getFieldValue(row, 'right');
          var cableVal    = getFieldValue(row, 'cable');
          var lengthEl    = row.querySelector('.caf__length-input');
          var lengthVal   = lengthEl   ? lengthEl.value.trim()   : '';
          var quantityEl  = row.querySelector('.caf__quantity-input');
          var quantityVal = quantityEl ? quantityEl.value.trim() : '';

          if (!leftVal && !rightVal && !cableVal && !lengthVal && !quantityVal) return;

          lines.push('\n\n--- Item ' + idx + ' ---');
          lines.push('Left Connector:  ' + (leftVal     || '(not selected)'));
          lines.push('Right Connector: ' + (rightVal    || '(not selected)'));
          lines.push('Cable:           ' + (cableVal    || '(not selected)'));
          lines.push('Cable Length:    ' + (lengthVal   || '(not entered)'));
          lines.push('Quantity:        ' + (quantityVal || '(not entered)'));
        });

        if (!lines.length) {
          alert('Please fill in at least one row before submitting.');
          return;
        }

        if (!valid) {
          var firstErr = container.querySelector('.caf__input--error');
          if (firstErr) firstErr.focus();
          return;
        }

        var body = 'Cable Assembly Request\n\n'
          + lines.join('\n')
          + '\n\n---\nFrom: ' + name + ' <' + email + '>';

        bodyField.value   = body;
        emailHidden.value = email;
        nameHidden.value  = name;

        /* Disable submit while sending */
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';

        var formData = new FormData(contactForm);
        fetch(contactForm.action, {
          method:  'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body:    new URLSearchParams(formData).toString()
        })
        .then(function () {
          showJsSuccess();
        })
        .catch(function () {
          /* Network failure — fall back to native submit */
          hiddenSubmit.click();
        });
      });
    }

    /* ----------------------------------------------------------
       JS success + countdown reset
    ---------------------------------------------------------- */
    function showJsSuccess() {
      if (formContent) formContent.hidden = true;
      if (jsSuccess)   jsSuccess.hidden   = false;

      var seconds = 7;
      if (jsNotice) jsNotice.textContent = 'Form will reset in ' + seconds + ' seconds…';

      var interval = setInterval(function () {
        seconds--;
        if (jsNotice) jsNotice.textContent = 'Form will reset in ' + seconds + ' seconds…';
        if (seconds <= 0) {
          clearInterval(interval);
          if (jsSuccess)   jsSuccess.hidden   = true;
          if (formContent) formContent.hidden = false;
          resetForm();
        }
      }, 1000);
    }

    function resetForm() {
      /* Clear all search inputs in every row */
      rowsEl.querySelectorAll('.caf__search-input').forEach(function (inp) {
        inp.value = '';
        inp.classList.remove('caf__input--selected', 'caf__input--error');
      });
      rowsEl.querySelectorAll('.caf__selected-value').forEach(function (hid) {
        hid.value = '';
      });
      rowsEl.querySelectorAll('.caf__length-input, .caf__quantity-input').forEach(function (inp) {
        inp.value = '';
        inp.classList.remove('caf__input--error');
      });
      rowsEl.querySelectorAll('.caf__dropdown').forEach(function (dd) {
        dd.hidden = true;
        dd.innerHTML = '';
      });

      /* Remove all dynamically-added rows, keep only the first */
      var allRows = rowsEl.querySelectorAll('.caf__row');
      allRows.forEach(function (row, i) { if (i > 0) row.remove(); });

      /* Reset Add More counter */
      if (addBtn) {
        addBtn.setAttribute('data-count', '0');
        addBtn.disabled = false;
      }

      /* Clear + re-enable customer fields */
      if (custName)  { custName.value  = ''; custName.classList.remove('caf__input--error');  }
      if (custEmail) { custEmail.value = ''; custEmail.classList.remove('caf__input--error'); }

      /* Re-enable submit button */
      if (submitBtn) {
        submitBtn.disabled    = false;
        submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Submit Request';
      }
    }

    function getFieldValue(row, searchType) {
      var field = row.querySelector('.caf__field[data-search-type="' + searchType + '"]');
      if (!field) return '';
      var hidden = field.querySelector('.caf__selected-value');
      return hidden ? hidden.value.trim() : '';
    }

    /* ----------------------------------------------------------
       Boot — init the first static row, store submit label
    ---------------------------------------------------------- */
    if (submitBtn) submitBtn.setAttribute('data-label', submitBtn.textContent.trim());
    var firstRow = rowsEl ? rowsEl.querySelector('.caf__row') : null;
    if (firstRow) initRow(firstRow, true);
  }

  /* ============================================================
     Auto-init helpers
     ============================================================ */
  function initAll() {
    document.querySelectorAll('.caf[data-section-id]').forEach(function (el) {
      if (!el.hasAttribute('data-caf-ready')) {
        el.setAttribute('data-caf-ready', 'true');
        new CableAssemblyForm(el);
      }
    });
  }

  /* Run on DOMContentLoaded or immediately if already parsed */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor: re-init when a section is reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target.querySelector('.caf[data-section-id]');
    if (container && !container.hasAttribute('data-caf-ready')) {
      container.setAttribute('data-caf-ready', 'true');
      new CableAssemblyForm(container);
    }
  });

  /* ── Helpers ── */
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

})();
